module.exports = __webpack_public_path__ + "img/123.161807b9.jpg";